export default {
  HOME: '/',
  PROJECTS: '/projects',
  CONTACT: '/contact',
  BLOG: '/blog',
};
